import Work1 from '../../assets/blprime.jpg';
// import Work2 from '../../assets/work2.jpg';
import Work3 from '../../assets/flightticketapp-figma.jpg';
// import Work4 from '../../assets/work4.jpg';
import Work5 from '../../assets/site-evely.jpg';

export const projectsData = [
    {
      id: 1,
      image: Work1,
      title: "Bl Prime - Study Case",
      category: "web",
        link: 'https://movie-app-eta-lime-27.vercel.app/'
    },
    // {
    //   id: 2,
    //   image: Work2,
    //   title: "App movil",
    //   category: "app",
    // },
    {
      id: 3,
      image: Work3,
      title: "Flight Ticket App",
      category: "design",
      link: 'https://www.figma.com/proto/ZWBoMZ6MtTcAXzJjWbdnTu/Book-Flight-App?node-id=2-92&p=f&t=N3CeXntDcJQgv3Fi-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=2%3A92'
    },
    // {
    //   id: 4,
    //   image: Work4,
    //   title: "App movil",
    //   category: "app",
    // },
    {
      id: 5,
      image: Work5,
      title: "Web site",
      category: "web",
      link: 'https://evelythompsonpsicologa.com.br/'
    },
  ];

  export const projectsNav = [
    {
        name: "all",
    },
    {
        name: "web",
    },
    {
        name: "app",
    },
    {
        name: "design",
    },
  ];